import { Component, input, output } from '@angular/core'

export type EventTrackingCardKey = 'database' | 'registration' | 'traffic' | 'capacity' | 'financial'

@Component({
  selector: 'app-event-tracking-card',
  standalone: true,
  templateUrl: './event-tracking-card.component.html',
  styleUrl: './event-tracking-card.component.scss'
})
export class EventTrackingCardComponent {
  public readonly label = input.required<string>()
  public readonly subLabel = input<string | undefined>(undefined)
  public readonly loading = input(false)
  public readonly readonly = input(false)
  public readonly icon = input.required<EventTrackingCardKey>()
  public readonly cardClick = output<EventTrackingCardKey>()

  /**
   * Handles the selection of the card.
   * @returns {void}
   */
  public onCardClick(): void {
    if (this.readonly()) return
    this.cardClick.emit(this.icon())
  }
}
